import styled from 'styled-components';
import {
  MenuList,
  MenuListItem,
  SVGIcon,
} from '@pearsontechnology/aero-components';
import color from 'tinycolor2';

export const List = styled(MenuList)`
  padding: 20px 30px 0;
  height: 339px;
  overflow-x: hidden;
  overflow-y: auto;

  :after {
    content: '';
    display: block;
    padding-bottom: 140px;
  }
`;

export const ListItem = styled(MenuListItem)`
  display: flex;
  height: auto;
  min-height: min-content;
  font-size: 14px;
  line-height: 18px;
  padding-top: 5px;
  padding-bottom: 5px;

  &:focus {
    box-shadow: none;
  }

  & svg {
    margin-right: 15px;
  }
`;

export const BackButton = styled.button`
  display: flex;
  cursor: pointer;
  height: 28px;
  min-height: 28px;
  text-align:left;
  padding-left: 6px;
  padding-right: 6px;
  border-radius: 4px;
  margin-bottom: 5px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: background 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: ${(props) =>
    props.disabled ?
      color(props.theme['color.text.body']).setAlpha(0.3).toString() :
      props.theme['color.text.body']
};
  pointer-events: ${(props) => props.disabled ? 'none' : 'auto'};

  &:hover {
    outline: none;
    background-color: ${(props) => color(props.theme['color.text.body']).setAlpha(0.05).toString()};
  }
`;

export const Label = styled.span`
  flex-grow: 1;
  font-size: 16px;
  line-height: 24px;
  white-space: nowrap;
  margin-left: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
`;

export const IconBack = styled(SVGIcon)`
  margin-top: 5px;
  fill: ${(props) => props.disabled ?
    color(props.theme['color.text.body']).setAlpha(0.3).toString() :
    props.theme['color.text.body']
}
`;
